import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Ricerca from "@/pages/Ricerca";
import Liste from "@/pages/Liste";
import ListaDetail from "@/pages/ListaDetail";
import EmailTemplate from "@/pages/EmailTemplate";
import Coda from "@/pages/Coda";
import Impostazioni from "@/pages/Impostazioni";
import PublicAnalisiV2 from "@/pages/PublicAnalisiV2";
import Crm from "@/pages/Crm";
import Scopri from "@/pages/Scopri";
import Engagement from "@/pages/Engagement";
import Funnel from "@/pages/Funnel";
import LeadInbound from "@/pages/LeadInbound";
import Importa from "@/pages/Importa";
import SpiegazioniCriticita from "@/pages/SpiegazioniCriticita";
import FormBuilder from "@/pages/FormBuilder";
import ProblemCatalog from "@/pages/ProblemCatalog";
import Privacy from "@/pages/Privacy";

const Protected = ({ children }) => {
  const token = localStorage.getItem("mv_token");
  if (!token) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/analisi/:token" element={<PublicAnalisiV2 />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/" element={<Protected><Dashboard /></Protected>} />
        <Route path="/ricerca" element={<Protected><Ricerca /></Protected>} />
        <Route path="/crm" element={<Protected><Crm /></Protected>} />
        <Route path="/liste" element={<Protected><Liste /></Protected>} />
        <Route path="/liste/:id" element={<Protected><ListaDetail /></Protected>} />
        <Route path="/liste/:id/email-template" element={<Protected><EmailTemplate /></Protected>} />
        <Route path="/coda" element={<Protected><Coda /></Protected>} />
        <Route path="/scopri" element={<Protected><Scopri /></Protected>} />
        <Route path="/engagement" element={<Protected><Engagement /></Protected>} />
        <Route path="/funnel" element={<Protected><Funnel /></Protected>} />
        <Route path="/lead-inbound" element={<Protected><LeadInbound /></Protected>} />
        <Route path="/importa" element={<Protected><Importa /></Protected>} />
        <Route path="/settings" element={<Protected><Impostazioni /></Protected>} />
        <Route path="/spiegazioni" element={<Protected><SpiegazioniCriticita /></Protected>} />
        <Route path="/catalogo-problemi" element={<Protected><ProblemCatalog /></Protected>} />
        <Route path="/forms" element={<Protected><FormBuilder /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
